import http from './http'

export function getSuppliers() {
  return http.get('supplier').then((res) => res.data)
}

export function createSupplier(data) {
  return http.post('supplier', data).then((res) => res.data)
}

export function updateSupplier(id, data) {
  return http.put(`supplier/${id}`, data).then((res) => res.data)
}

export function deleteSupplier(id) {
  return http.delete(`supplier/${id}`).then((res) => res.data)
}
